// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"bde61391","455":"987c9178"}[chunkId] + ".chunk.js";
};